import React from "react";
import Layout from "../Components/layout";
import Nepal from "../Components/window/Nepal/nepal";
import { Breadcrumb } from "../Components/window/Breadcrumb/breadcrumb";

export const NepalPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Breadcrumb items={[{ label: "Nepal" }]} />
      <div className="pt-4 md:pt-6">
        <Nepal />
      </div>
    </Layout>
  );
};
